import Checkbox from "../shared/checkbox/checkbox";
import { stylizationWrapper, stylizationVerticalAlign } from "../shared/stylization";
import Wrapper from "../shared/wrapper/wrapper";
import { CheckboxFieldProps } from "./types/checkboxFieldProps";
import "./checkboxField.scss";
import { useState } from "react";
import ErrorTip from "../shared/errorTip/errorTip";
import { ReactComponent as cancel } from "../../icons/cancel.svg";

const CheckboxField = (props: CheckboxFieldProps) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onChangeCheckbox = (_event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.forMultiChange) {
      props.forMultiChange(props.value, !props.inputChecked, props.indexElement);
    }
  };

  let stylization = props.style !== undefined ? props.style : stylizationWrapper;

  if(props.labelName === "zbiornik wód powierzchniowych"){
    stylization = {maxWidth:"174px", textAlign: "left"};
  }

  const checkMarkStylization: React.CSSProperties = {
    verticalAlign: "middle",
    marginRight: "15px",
  };

  const onChange = props.onChange !== undefined ? props.onChange : onChangeCheckbox;

  const getClass = () => {
    return props.checkmarkSmall
      ? `checkmark checkmarkSmall ${props.inputChecked ? "isCheckedBack" : ""}`
      : `checkmark ${props.inputChecked ? "isCheckedBack" : ""}`;
  };

  const toggleFromLabel = () => {
    if (props.disabled) return;

    if (props.onChange) {
      props.onChange(
        {
          target: { checked: !props.inputChecked },
        } as unknown as React.ChangeEvent<HTMLInputElement>
      );
      return;
    }

    // fallback dla trybu multi
    if (props.forMultiChange) {
      props.forMultiChange(props.value, !props.inputChecked, props.indexElement);
    }
  };

  const onLabelKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (props.disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFromLabel();
    }
  };

  return (
    <Wrapper
      style={stylization}
      children={
        <>
          <div className={`container ${props.disabled ? "containerDisabled" : ""}`}>
            <label className="checkboxHitArea">
              <Checkbox
                disabled={props.disabled}
                checked={props.inputChecked}
                onChange={onChange}
                setIsFocused={setIsFocused}
              />

              <div style={{ display: "flex" }}>
                <div
                  id="checkboxes"
                  className={isFocused ? `${getClass()} focusedCheckboxIndicator` : getClass()}
                  style={checkMarkStylization}
                >
                  <span
                    className={
                      props.checkmarkSmall
                        ? `${props.inputChecked ? "isCheckedSmall" : "isNotCheckedSmall"}`
                        : `${props.inputChecked ? "isChecked" : "isNotCheckedSmall"}`
                    }
                  />
                </div>
              </div>
            </label>

            <span
              className={`body-txt-large labelText ${props.disabled ? "labelTextDisabled" : ""}`}
              style={stylizationVerticalAlign}
              role="button"
              tabIndex={props.disabled ? -1 : 0}
              onClick={toggleFromLabel}
              onKeyDown={onLabelKeyDown}
              aria-disabled={props.disabled ? "true" : "false"}
            >
              {props.labelName}
            </span>
          </div>

          {props.errorTip && (
            <ErrorTip tipText={props.errorTip} tipType="errorTip" additionalIcon={cancel} />
          )}
        </>
      }
    />
  );
};

export default CheckboxField;